import { buildLevelSeedState } from "../data/level.seed";

function buildSeedCache(): Map<string, string> {
  const map = new Map<string, string>();
  for (const l3 of buildLevelSeedState().level3) {
    map.set(l3.id, l3.label);
  }
  return map;
}

let level3Labels = buildSeedCache();

/** Sync label lookup for mock payloads; refreshed when level options load. */
export function setLevel3LabelCache(
  options: { id: string; label: string }[]
): void {
  level3Labels = buildSeedCache();
  for (const option of options) {
    level3Labels.set(option.id, option.label);
  }
}

export function resolveLevel3Label(level3Id: string): string {
  return level3Labels.get(level3Id) ?? level3Id;
}
